/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { TFunction } from "i18next";
import React, { FC } from "react";
import { FormLabel } from "react-bootstrap";
import { SignUpAction } from "@src/pages/signup/ducks/slices";
import { getLatestEula } from "@src/reducers/operations/eulaOperation";
import { useAppDispatch } from "@src/config/store";

interface TermAndServiceButtonProps {
  t: TFunction;
}

export const TermAndServiceButton: FC<TermAndServiceButtonProps> = ({ t }) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <FormLabel className="custom-checkbox d-inline-block m-t-md">
        <input
          type="checkbox"
          name="remember"
          className="custom-control-input"
          onChange={(e) => {
            dispatch(SignUpAction.eulaSignUpAgreement(e.target.checked));
          }}
        />
        <span className="custom-control-label" />
      </FormLabel>
      {t("register.terms_service_sentence")}&nbsp;
      <a
        href={"#terms"}
        onClick={() => {
          dispatch(getLatestEula());
          dispatch(SignUpAction.showSignUpEulaAgreementInfo(true));
        }}
      >
        {t("register.terms_service")}
      </a>
    </>
  );
};
